// Module
var code = "<div class=\"sign-in-form\"> <div v-if=\"sending\"> <h4>Confirming Email Address Change...</h4> </div> <div v-if=\"!sending\"> <div v-if=\"!didError\"> <h1>Success!</h1> <p>Please <a href=\"#/login\">login</a> with your new email address</p> </div> <div v-if=\"didError\"> <h1>Oh No!</h1> <h2>Something went wrong..</h2> </div> </div> </div> ";
// Exports
export default code;